import type { SiteConfig } from '@/hooks/useSiteConfig';

export const defaultSiteConfig: SiteConfig = {
  version: 21,
  logo: 'https://readdy.ai/api/search-image?query=Minimalist%20professional%20logo%20for%20Vietnamese%20refrigeration%20repair%20company%20named%20Dien%20Lanh%20Nha%20Trang%20featuring%20stylized%20snowflake%20merged%20with%20gentle%20ocean%20wave%20symbol%20teal%20and%20sky%20blue%20gradient%20modern%20clean%20typography%20white%20background%20flat%20design%20high%20quality%20commercial%20logo&width=300&height=100&seq=logo_nhatrang_2025v1&orientation=landscape',
  logoWidth: 300,
  logoHeight: 100,
  heroStyle: {
    paddingTop: 40, paddingBottom: 64, gap: 24, maxWidth: 960,
    titleSize: 46, subtitleSize: 18, labelSize: 14,
  },
  howItWorksStyle: {
    paddingTop: 88, paddingBottom: 88, gap: 24, maxWidth: 1024,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
    bgColor: '#f9fafb',
  },
  featuresStyle: {
    paddingTop: 88, paddingBottom: 88, gap: 40, maxWidth: 1060,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
  },
  statsStyle: {
    paddingTop: 72, paddingBottom: 72, gap: 24, maxWidth: 1024,
    titleSize: 48, subtitleSize: 15, labelSize: 13,
    bgColor: '#0d7377',
  },
  screenshotsStyle: {
    paddingTop: 88, paddingBottom: 88, gap: 16, maxWidth: 1060,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
    bgColor: '#f9fafb',
  },
  testimonialsStyle: {
    paddingTop: 88, paddingBottom: 88, gap: 24, maxWidth: 1024,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
  },
  pricingStyle: {
    paddingTop: 88, paddingBottom: 88, gap: 24, maxWidth: 1060,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
    bgColor: '#f9fafb',
  },
  faqStyle: {
    paddingTop: 88, paddingBottom: 88, gap: 24, maxWidth: 1024,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
  },
  contactStyle: {
    paddingTop: 88, paddingBottom: 88, gap: 32, maxWidth: 1060,
    titleSize: 36, subtitleSize: 16, labelSize: 14,
    bgColor: '#f9fafb',
  },
  footerStyle: {
    paddingTop: 56, paddingBottom: 56, gap: 32, maxWidth: 1024,
    titleSize: 14, subtitleSize: 12, labelSize: 12,
    bgColor: '#f3f4f6',
  },
  nav: {
    howItWorks: 'Quy trình',
    features: 'Dịch vụ',
    pricing: 'Bảng giá',
    contact: 'Liên hệ',
  },
  simpleNav: [
    { label: 'Trang chủ', href: '/' },
    { label: 'Dịch vụ', href: '/#dich-vu' },
    { label: 'Quy trình', href: '/#quy-trinh' },
    { label: 'Bảng giá', href: '/#bang-gia' },
    { label: 'Liên hệ', href: '/#lien-he' },
  ],
  simpleBanner: {
    images: [
      'https://readdy.ai/api/search-image?query=Professional%20air%20conditioner%20repair%20technician%20in%20uniform%20working%20on%20outdoor%20AC%20unit%20in%20Vietnamese%20urban%20residential%20area%20with%20tools%20and%20equipment%20modern%20clean%20service%20photo%20style%20bright%20natural%20lighting%20high%20quality&width=1920&height=500&seq=banner1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Refrigerator%20repair%20technician%20servicing%20modern%20stainless%20steel%20fridge%20in%20clean%20Vietnamese%20kitchen%20interior%20professional%20service%20scene%20bright%20warm%20lighting%20high%20quality%20photography&width=1920&height=500&seq=banner2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Washing%20machine%20repair%20service%20technician%20fixing%20front%20load%20washer%20in%20Vietnamese%20home%20laundry%20room%20professional%20uniform%20with%20tools%20bright%20clean%20modern%20photography%20style&width=1920&height=500&seq=banner3&orientation=landscape',
    ],
    alt: 'Dịch vụ sửa chữa điều hòa, điện lạnh',
    link: '/dat-lich',
    autoPlay: true,
    interval: 5000,
  },
  simpleContent: {
    sections: [
      {
        id: 'dich-vu',
        label: 'Dịch vụ của chúng tôi',
        title: 'Các dịch vụ sửa chữa điện lạnh',
        articles: [
          {
            title: 'Sửa chữa điều hòa',
            content: 'Chuyên sửa chữa, bảo dưỡng điều hòa các hãng Daikin, Panasonic, LG, Samsung, Mitsubishi, Toshiba. Xử lý triệt để các lỗi: không mát, chảy nước, kêu to, hỏng block, thiếu gas. Bảo hành tối thiểu 3 tháng cho mỗi sửa chữa. Đội ngũ kỹ thuật viên được đào tạo chuyên sâu, có chứng chỉ nghề.',
            image: 'https://readdy.ai/api/search-image?query=Technician%20repairing%20wall%20mounted%20air%20conditioner%20indoor%20unit%20in%20clean%20modern%20Vietnamese%20living%20room%20professional%20service%20bright%20natural%20lighting%20high%20quality%20photo&width=800&height=400&seq=sv_dieuhoa&orientation=landscape',
          },
          {
            title: 'Sửa chữa tủ lạnh',
            content: 'Sửa tủ lạnh không lạnh, đóng tuyết, kêu to, hỏng board mạch, thay block, thay gas. Hỗ trợ tủ lạnh inverter và thường. Thay thế linh kiện chính hãng, bảo hành lên đến 6 tháng. Kiểm tra miễn phí trước khi báo giá.',
          },
          {
            title: 'Sửa chữa máy giặt',
            content: 'Sửa máy giặt cửa trước và cửa trên các lỗi: không xả nước, không vắt, kêu rung lắc, hỏng board, rò rỉ nước. Bảo dưỡng định kỳ giúp máy hoạt động êm, tiết kiệm điện. Thay thế linh kiện chính hãng với giá cả hợp lý.',
            image: 'https://readdy.ai/api/search-image?query=Technician%20repairing%20front%20loading%20washing%20machine%20in%20Vietnamese%20home%20laundry%20area%20professional%20service%20scene%20with%20tools%20bright%20clean%20modern%20photo%20style&width=800&height=400&seq=sv_maygiat&orientation=landscape',
          },
          {
            title: 'Sửa chữa bình nóng lạnh',
            content: 'Sửa bình nóng lạnh không nóng, rò rỉ nước, chập điện, hỏng rơ le nhiệt, thay thanh nhiệt, thay ruột bình. Vệ sinh bình nóng lạnh định kỳ giúp tăng tuổi thọ thiết bị và đảm bảo an toàn cho gia đình.',
          },
        ],
      },
      {
        id: 'khuyen-mai',
        label: 'Ưu đãi đặc biệt',
        title: 'Khuyến mãi tháng này',
        articles: [
          {
            title: 'Bảo dưỡng điều hòa chỉ 150.000đ',
            content: 'Gói bảo dưỡng điều hòa toàn diện bao gồm: vệ sinh dàn lạnh, dàn nóng, kiểm tra gas, kiểm tra hệ thống điện. Chỉ 150.000đ/máy khi đặt lịch trong tháng này. Áp dụng cho điều hòa từ 9.000 - 24.000 BTU.',
            image: 'https://readdy.ai/api/search-image?query=Air%20conditioner%20maintenance%20service%20cleaning%20indoor%20AC%20unit%20coils%20with%20professional%20tools%20in%20Vietnamese%20home%20modern%20clean%20bright%20service%20scene%20high%20quality%20photo&width=800&height=400&seq=km_baoduong&orientation=landscape',
          },
          {
            title: 'Giảm 20% cho khách hàng mới',
            content: 'Khách hàng lần đầu sử dụng dịch vụ của chúng tôi được giảm ngay 20% cho bất kỳ dịch vụ sửa chữa nào. Ưu đãi không giới hạn số lượng máy. Kết hợp với gói bảo dưỡng để tiết kiệm tối đa.',
          },
        ],
      },
      {
        id: 'tai-sao-chon',
        label: 'Tại sao chọn chúng tôi',
        title: 'Ưu điểm của dịch vụ',
        articles: [
          {
            title: 'Đội ngũ chuyên nghiệp',
            content: 'Kỹ thuật viên được đào tạo bài bản, có chứng chỉ nghề và nhiều năm kinh nghiệm thực tế. Xử lý triệt để vấn đề từ gốc rễ, không chữa cháy tạm bợ. Luôn sử dụng linh kiện chính hãng, chất lượng cao.',
          },
          {
            title: 'Giá cả minh bạch',
            content: 'Báo giá rõ ràng trước khi sửa chữa. Không phát sinh chi phí ẩn. Khách hàng được quyền từ chối nếu không đồng ý giá. Nhiều gói dịch vụ phù hợp với mọi ngân sách.',
          },
          {
            title: 'Bảo hành dài hạn',
            content: 'Tất cả dịch vụ sửa chữa đều có bảo hành tối thiểu 3 tháng. Bảo hành lên đến 12 tháng cho các hạng mục thay thế linh kiện lớn. Hỗ trợ miễn phí trong thời gian bảo hành nếu có vấn đề phát sinh.',
          },
        ],
      },
    ],
  },
  hero: {
    title: 'Sửa chữa điều hòa, điện lạnh tại nhà - Giá rẻ, bảo hành dài hạn',
    subtitle: 'Đội ngũ kỹ thuật viên chuyên nghiệp với hơn 10 năm kinh nghiệm tại Nha Trang. Sửa chữa tận nơi, báo giá trước, không phát sinh chi phí. Dịch vụ 24/7 kể cả ngày lễ.',
    buttonText: 'Đặt lịch ngay',
    phoneImage: 'https://readdy.ai/api/search-image?query=Technician%20holding%20toolbox%20and%20air%20conditioning%20diagnostic%20tool%20in%20professional%20uniform%20with%20friendly%20smile%20modern%20Vietnamese%20home%20service%20scene%20bright%20lighting%20clean%20background&width=500&height=500&seq=hero_phone&orientation=squarish',
    logoImage: 'https://readdy.ai/api/search-image?query=Minimalist%20professional%20logo%20for%20Vietnamese%20refrigeration%20repair%20company%20named%20Dien%20Lanh%20Nha%20Trang%20featuring%20stylized%20snowflake%20merged%20with%20gentle%20ocean%20wave%20symbol%20teal%20and%20sky%20blue%20gradient%20modern%20clean%20typography%20white%20background%20flat%20design%20high%20quality%20commercial%20logo&width=300&height=100&seq=logo_nhatrang_2025v2&orientation=landscape',
  },
  howItWorks: {
    label: 'Quy trình làm việc',
    title: 'QUY TRÌNH SỬA CHỮA 4 BƯỚC',
    subtitle: 'Quy trình chuẩn, minh bạch giúp khách hàng yên tâm tuyệt đối. Từ đặt lịch đến hoàn thành chỉ trong vài giờ.',
    items: [
      {
        title: '1. Đặt lịch online hoặc gọi điện',
        description: 'Đặt lịch qua website hoặc hotline 0358 218 547. Tư vấn viên sẽ xác nhận và sắp xếp kỹ thuật viên phù hợp trong vòng 30 phút.',
        icon: 'ri-calendar-check-line',
      },
      {
        title: '2. Kiểm tra và báo giá',
        description: 'Kỹ thuật viên đến tận nơi, kiểm tra thiết bị miễn phí. Báo giá chi tiết trước khi tiến hành sửa chữa. Khách hàng quyết định có sửa hay không.',
        icon: 'ri-file-list-3-line',
      },
      {
        title: '3. Sửa chữa chuyên nghiệp',
        description: 'Thực hiện sửa chữa với linh kiện chính hãng, dụng cụ chuyên dụng. Đảm bảo chất lượng và an toàn tuyệt đối trong suốt quá trình.',
        icon: 'ri-tools-line',
      },
      {
        title: '4. Nghiệm thu và bảo hành',
        description: 'Khách hàng kiểm tra, nghiệm thu kết quả. Cung cấp phiếu bảo hành chính hãng. Hỗ trợ miễn phí nếu có vấn đề trong thời gian bảo hành.',
        icon: 'ri-shield-check-line',
      },
    ],
  },
  features: {
    label: 'Dịch vụ chính',
    title: 'Giải pháp điện lạnh toàn diện',
    subtitle: 'Cung cấp đầy đủ các dịch vụ sửa chữa, bảo dưỡng, lắp đặt thiết bị điện lạnh cho gia đình và doanh nghiệp.',
    items: [
      {
        title: 'Sửa chữa & Bảo dưỡng điều hòa',
        description: 'Dịch vụ sửa chữa, vệ sinh, nạp gas điều hòa tại nhà với kỹ thuật viên được đào tạo chuyên sâu từng hãng.',
        bullets: [
          'Sửa điều hòa không mát, chảy nước, kêu to, hỏng block',
          'Vệ sinh điều hòa định kỳ giúp tiết kiệm 30% điện năng',
          'Nạp gas điều hòa chuẩn, đúng loại gas theo hãng sản xuất',
          'Lắp đặt điều hòa mới chuyên nghiệp, bảo hành lắp đặt 12 tháng',
        ],
        image: 'https://readdy.ai/api/search-image?query=Split%20air%20conditioner%20indoor%20and%20outdoor%20units%20being%20serviced%20by%20technician%20with%20gauges%20and%20refrigerant%20in%20Vietnamese%20apartment%20balcony%20professional%20service%20equipment%20bright%20clean%20photo&width=500&height=600&seq=feature1&orientation=portrait',
        imagePosition: 'left',
      },
      {
        title: 'Sửa chữa tủ lạnh & Máy giặt',
        description: 'Chuyên sửa tủ lạnh, máy giặt các thương hiệu nội địa và nhập khẩu. Thay thế linh kiện chính hãng với giá tốt.',
        bullets: [
          'Sửa tủ lạnh không lạnh, đóng tuyết, kêu to, hỏng board',
          'Sửa máy giặt không xả nước, không vắt, kêu rung lắc',
          'Thay block, gas, board mạch chính hãng có bảo hành dài hạn',
          'Bảo dưỡng định kỳ giúp thiết bị hoạt động bền bỉ, tiết kiệm điện',
        ],
        image: 'https://readdy.ai/api/search-image?query=Modern%20stainless%20steel%20refrigerator%20and%20front%20load%20washing%20machine%20in%20Vietnamese%20home%20kitchen%20and%20laundry%20area%20clean%20bright%20interior%20professional%20product%20photo%20style&width=500&height=600&seq=feature2&orientation=portrait',
        imagePosition: 'right',
      },
    ],
  },
  stats: {
    items: [
      { value: '10+', label: 'NĂM KINH NGHIỆM' },
      { value: '15,000+', label: 'KHÁCH HÀNG' },
      { value: '50+', label: 'KỸ THUẬT VIÊN' },
      { value: '98%', label: 'HÀI LÒNG' },
    ],
  },
  screenshots: {
    label: 'Hình ảnh thực tế',
    title: 'Công việc của chúng tôi',
    subtitle: 'Hình ảnh thực tế từ các công việc sửa chữa, bảo dưỡng điều hòa và thiết bị điện lạnh.',
    items: [
      { image: 'https://readdy.ai/api/search-image?query=Air%20conditioner%20cleaning%20service%20technician%20removing%20front%20panel%20and%20cleaning%20filter%20coils%20in%20Vietnamese%20home%20living%20room%20professional%20service%20close%20up%20detailed%20shot%20bright&width=400&height=600&seq=screen1&orientation=portrait', alt: 'Vệ sinh điều hòa' },
      { image: 'https://readdy.ai/api/search-image?query=Refrigerator%20repair%20technician%20using%20multimeter%20to%20check%20compressor%20in%20Vietnamese%20kitchen%20professional%20service%20detailed%20close%20up%20bright%20clean&width=400&height=600&seq=screen2&orientation=portrait', alt: 'Sửa tủ lạnh' },
      { image: 'https://readdy.ai/api/search-image?query=Washing%20machine%20repair%20technician%20checking%20drum%20and%20motor%20in%20Vietnamese%20laundry%20room%20professional%20service%20close%20up%20detailed%20bright%20clean&width=400&height=600&seq=screen3&orientation=portrait', alt: 'Sửa máy giặt' },
      { image: 'https://readdy.ai/api/search-image?query=Electric%20water%20heater%20repair%20technician%20checking%20thermostat%20and%20heating%20element%20in%20Vietnamese%20bathroom%20professional%20service%20close%20up%20bright&width=400&height=600&seq=screen4&orientation=portrait', alt: 'Sửa bình nóng lạnh' },
      { image: 'https://readdy.ai/api/search-image?query=AC%20refrigerant%20recharge%20service%20technician%20connecting%20gauges%20to%20outdoor%20condenser%20unit%20in%20Vietnamese%20apartment%20building%20professional%20service%20bright&width=400&height=600&seq=screen5&orientation=portrait', alt: 'Nạp gas điều hòa' },
    ],
  },
  testimonials: {
    label: 'KHÁCH HÀNG NÓI GÌ',
    title: 'Đánh giá từ khách hàng',
    subtitle: 'Hàng nghìn khách hàng đã tin tưởng và hài lòng với dịch vụ của chúng tôi.',
    items: [
      { quote: '"Kỹ thuật viên đến rất nhanh sau khi đặt lịch, sửa điều hòa chỉ trong 1 giờ. Giá hợp lý, bảo hành 6 tháng. Rất hài lòng và sẽ giới thiệu cho bạn bè!"', name: 'Chị Nguyễn Thị Hoa', role: 'Quận Cầu Giấy, Hà Nội', avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Vietnamese%20middle%20aged%20woman%20portrait%20smiling%20warm%20expression%20casual%20clothes%20bright%20natural%20lighting%20clean%20background%20professional%20headshot&width=100&height=100&seq=avatar1&orientation=squarish' },
      { quote: '"Tủ lạnh nhà mình bị đóng tuyết nặng, kỹ thuật viên kiểm tra kỹ lưỡng và giải thích rõ ràng. Sửa xong tủ lạnh chạy êm, tiết kiệm điện hẳn. Cảm ơn đội ngũ rất nhiều!"', name: 'Anh Trần Văn Minh', role: 'Quận 7, TP.HCM', avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Vietnamese%20middle%20aged%20man%20portrait%20smiling%20professional%20appearance%20casual%20clothes%20bright%20natural%20lighting%20clean%20background%20headshot&width=100&height=100&seq=avatar2&orientation=squarish' },
      { quote: '"Dịch vụ bảo dưỡng điều hòa giá rất tốt, chỉ 150k mà làm rất kỹ. Máy chạy mát hơn hẳn, không còn mùi hôi. Nhân viên lịch sự, chuyên nghiệp."', name: 'Chị Lê Thị Lan', role: 'Quận Hai Bà Trưng, Hà Nội', avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Vietnamese%20young%20woman%20portrait%20smiling%20warm%20expression%20professional%20casual%20bright%20natural%20lighting%20clean%20background%20headshot&width=100&height=100&seq=avatar3&orientation=squarish' },
    ],
  },
  pricing: {
    label: 'BẢNG GIÁ DỊCH VỤ',
    title: 'Bảng giá sửa chữa điện lạnh',
    subtitle: 'Giá cả minh bạch, không phát sinh chi phí ẩn. Báo giá chính xác sau khi kiểm tra thiết bị.',
    items: [
      {
        name: 'Bảo dưỡng',
        price: '150.000đ',
        period: '/máy',
        features: ['Vệ sinh dàn lạnh & dàn nóng', 'Kiểm tra gas', 'Kiểm tra hệ thống điện', 'Kiểm tra block', 'Bảo hành 3 tháng'],
        buttonText: 'Đặt lịch',
        highlighted: false,
      },
      {
        name: 'Sửa chữa cơ bản',
        price: '300.000đ',
        period: '/lần',
        features: ['Sửa lỗi điều hòa không mát', 'Sửa chảy nước, kêu to', 'Thay tụ, thay quạt', 'Nạp gas R22/R410A', 'Bảo hành 6 tháng'],
        buttonText: 'Đặt lịch',
        highlighted: true,
      },
      {
        name: 'Sửa chữa nâng cao',
        price: 'Từ 500.000đ',
        period: '/lần',
        features: ['Sửa block, thay block', 'Thay board mạch', 'Sửa tủ lạnh/máy giặt', 'Thay linh kiện chính hãng', 'Bảo hành 12 tháng'],
        buttonText: 'Tư vấn ngay',
        highlighted: false,
      },
    ],
  },
  faq: {
    label: 'CÂU HỎI THƯỜNG GẶP',
    title: 'Giải đáp thắc mắc',
    subtitle: 'Những câu hỏi phổ biến mà khách hàng thường quan tâm khi sử dụng dịch vụ.',
    items: [
      {
        question: 'Thời gian kỹ thuật viên đến sửa mất bao lâu?',
        answer: 'Thông thường sau khi đặt lịch, kỹ thuật viên sẽ đến trong vòng 30 phút đến 2 giờ tùy khu vực. Trong giờ cao điểm (buổi trưa) có thể lâu hơn một chút. Chúng tôi sẽ thông báo chính xác thời gian đến qua điện thoại.',
      },
      {
        question: 'Giá sửa chữa có minh bạch không? Có phát sinh chi phí không?',
        answer: 'Chúng tôi báo giá chi tiết trước khi tiến hành sửa chữa. Khách hàng được quyền từ chối nếu không đồng ý giá. Không có chi phí ẩn hay phát sinh ngoài báo giá đã thỏa thuận. Kiểm tra thiết bị miễn phí.',
      },
      {
        question: 'Linh kiện thay thế có chính hãng không? Bảo hành bao lâu?',
        answer: 'Tất cả linh kiện thay thế đều là chính hãng hoặc OEM tương đương chất lượng. Bảo hành tối thiểu 3 tháng cho sửa chữa cơ bản và lên đến 12 tháng cho thay thế linh kiện lớn như block, board mạch.',
      },
      {
        question: 'Có hỗ trợ sửa chữa ngoài giờ hành chính và ngày lễ không?',
        answer: 'Có, chúng tôi cung cấp dịch vụ 24/7 kể cả ngày lễ, Tết. Phí dịch vụ ngoài giờ chỉ phụ thu thêm 50.000đ so với giờ hành chính. Đặt lịch qua hotline hoặc website để được ưu tiên.',
      },
    ],
    image: 'https://readdy.ai/api/search-image?query=Professional%20air%20conditioning%20repair%20service%20team%20with%20tools%20and%20equipment%20in%20clean%20modern%20workshop%20setting%20friendly%20confident%20pose%20Vietnamese%20technicians%20bright%20clean%20professional%20photo&width=500&height=500&seq=faq_team&orientation=squarish',
  },
  contact: {
    title: 'Liên hệ với chúng tôi',
    subtitle: 'ĐẶT LỊCH SỬA CHỮA',
    description: 'Gọi hotline hoặc để lại thông tin, kỹ thuật viên sẽ có mặt trong 30 phút. Địa chỉ: 124 Lê Hồng Phong, Nam Nha Trang, Khánh Hòa. Phục vụ 24/7 kể cả ngày lễ Tết.',
    formImage: 'https://readdy.ai/api/search-image?query=Friendly%20air%20conditioning%20technician%20talking%20on%20phone%20and%20checking%20schedule%20tablet%20in%20clean%20modern%20office%20setting%20Vietnamese%20professional%20service%20representative%20bright%20warm%20lighting&width=438&height=412&seq=contact_img&orientation=portrait',
  },
  authRegister: {
    title: 'ĐẶT LỊCH SỬA CHỮA',
    subtitle: 'Điền thông tin để đặt lịch dịch vụ sửa chữa điện lạnh',
    phoneLabel: 'Số điện thoại',
    usernameLabel: 'Họ và tên',
    buttonText: 'Đặt lịch',
    successMessage: 'Đặt lịch thành công! Chúng tôi sẽ liên hệ xác nhận trong vòng 15 phút.',
    errorMessage: 'Có lỗi xảy ra, vui lòng thử lại.',
    bgColor: '#f5f5f5',
    cardBg: '#ffffff',
    borderColor: '#0d7377',
    accentColor: '#0d7377',
    toolbar1: 'SỬA CHỮA ĐIỀU HÒA - DỊCH VỤ 24/7 KỂ CẢ NGÀY LỄ',
    toolbar2: 'BẢO DƯỠNG ĐIỀU HÒA CHỈ 150.000Đ - BẢO HÀNH 3 THÁNG',
    authLogo: 'https://readdy.ai/api/search-image?query=Professional%20air%20conditioning%20repair%20service%20company%20logo%20in%20Vietnamese%20modern%20flat%20design%20with%20cool%20blue%20and%20orange%20colors%20on%20transparent%20background%20featuring%20snowflake%20and%20wrench%20elements%20minimalist%20clean%20style&width=300&height=100&seq=dienlanhlogo3&orientation=landscape',
    authLogoWidth: 280,
    authLogoHeight: 100,
    gSheetUrl: 'https://script.google.com/macros/s/AKfycbyZ5r7b62ETEBD25ughwpMvzOnz8gvu1x7H9674uvw7W0npAz_azKTj6xgZDW7v3N6P/exec',
    referralCodeLabel: 'Địa chỉ',
    referralCodePlaceholder: 'Số nhà, đường, phường, quận',
    accountLabel: 'Loại thiết bị',
    accountPlaceholder: 'Điều hòa, tủ lạnh, máy giặt...',
    nicknameLabel: 'Mô tả lỗi',
    nicknamePlaceholder: 'Mô tả ngắn gọn tình trạng thiết bị',
    passwordLabel: 'Ngày mong muốn',
    passwordPlaceholder: 'VD: 2026-05-15',
    otpButtonText: '',
    otpPlaceholder: '',
    confirmCodeLabel: 'Mã xác nhận',
    confirmCodePlaceholder: '4 Chữ số',
    confirmCodeButtonText: 'Gửi',
    checkbox1Label: 'Tôi đồng ý nhận thông báo qua tin nhắn khi kỹ thuật viên đến',
    checkbox2Label: 'Tôi xác nhận thông tin trên là chính xác và đồng ý đặt lịch',
    termsLinkText: 'Điều khoản dịch vụ',
    termsUrl: '#',
    confirmButtonText: 'Xác nhận đặt lịch',
    accountValidationText: 'Vui lòng nhập thông tin chính xác',
    passwordShowIcon: 'ri-eye-line',
    passwordHideIcon: 'ri-eye-off-line',
  },
  authLogin: {
    title: 'Đăng nhập',
    subtitle: 'Quản lý đơn hàng và lịch sử dịch vụ',
    phoneLabel: 'Số điện thoại',
    usernameLabel: 'Mật khẩu',
    buttonText: 'Đăng nhập',
    successMessage: 'Đăng nhập thành công!',
    errorMessage: 'Có lỗi xảy ra, vui lòng thử lại.',
    bgColor: '#0a192f',
    cardBg: '#ffffff',
    borderColor: '#0d7377',
    accentColor: '#0d7377',
    toolbar1: 'SỬA CHỮA ĐIỀU HÒA - DỊCH VỤ 24/7 KỂ CẢ NGÀY LỄ',
    toolbar2: 'BẢO DƯỠNG ĐIỀU HÒA CHỈ 150.000Đ - BẢO HÀNH 3 THÁNG',
    authLogo: 'https://readdy.ai/api/search-image?query=Professional%20air%20conditioning%20repair%20service%20company%20logo%20in%20Vietnamese%20modern%20flat%20design%20with%20cool%20blue%20and%20orange%20colors%20on%20transparent%20background%20featuring%20snowflake%20and%20wrench%20elements%20minimalist%20clean%20style&width=300&height=100&seq=dienlanhlogo4&orientation=landscape',
    authLogoWidth: 280,
    authLogoHeight: 100,
    gSheetUrl: 'https://script.google.com/macros/s/AKfycbyZ5r7b62ETEBD25ughwpMvzOnz8gvu1x7H9674uvw7W0npAz_azKTj6xgZDW7v3N6P/exec',
    referralCodeLabel: '',
    referralCodePlaceholder: '',
    accountLabel: '',
    accountPlaceholder: '',
    nicknameLabel: '',
    nicknamePlaceholder: '',
    passwordLabel: '',
    passwordPlaceholder: '',
    otpButtonText: '',
    otpPlaceholder: '',
    confirmCodeLabel: '',
    confirmCodePlaceholder: '',
    confirmCodeButtonText: '',
    checkbox1Label: '',
    checkbox2Label: '',
    termsLinkText: '',
    termsUrl: '',
    confirmButtonText: '',
    accountValidationText: '',
    passwordShowIcon: 'ri-eye-line',
    passwordHideIcon: 'ri-eye-off-line',
  },
  footer: {
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20professional%20logo%20for%20Vietnamese%20refrigeration%20repair%20company%20named%20Dien%20Lanh%20Nha%20Trang%20featuring%20stylized%20snowflake%20merged%20with%20gentle%20ocean%20wave%20symbol%20teal%20and%20sky%20blue%20gradient%20modern%20clean%20typography%20white%20background%20flat%20design%20high%20quality%20commercial%20logo&width=200&height=70&seq=logo_nhatrang_2025v3&orientation=landscape',
    address: '124 Lê Hồng Phong, Nam Nha Trang, Tỉnh Khánh Hòa',
    phone: '0358 218 547',
    email: 'dichvu@dienlanhNhaTrang.vn',
    links1: ['Về chúng tôi', 'Dịch vụ', 'Bảng giá', 'Tin tức'],
    links2: ['Hướng dẫn đặt lịch', 'Chính sách bảo hành', 'Câu hỏi thường gặp', 'Liên hệ'],
    appStoreImage: '',
    playStoreImage: '',
    copyright: 'Điện Lạnh Nha Trang - Dịch vụ sửa chữa điều hòa, điện lạnh tại nhà - Uy tín, bảo hành dài hạn',
  },
};